





































































import { Component } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import OpportunityLostReasonDto from '@/models/Opportunities/OpportunityLostReasonDto'
import OpportunityLostReasonCreate from '@/components/OpportunityLostReasons/OpportunityLostReasonCreate.vue';
import OpportunityLostReasonEdit from '@/components/OpportunityLostReasons/OpportunityLostReasonEdit.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import { VuetifyConfirmObject } from 'vuetify-confirm';

@Component({
  name: 'OpportunityLostReasons',
  components: { OpportunityLostReasonCreate, OpportunityLostReasonEdit }
})
export default class extends GiganautVue {

    async beforeMount() {
        AgencySettingsModule.updateCurrentOpportunityLostReason(null);
    }

    async updateOpportunityLostReason(opportunityLostReason: OpportunityLostReasonDto) {
        AgencySettingsModule.updateCurrentOpportunityLostReason(opportunityLostReason);
    }

    get currentOpportunityLostReason() {
        return AgencySettingsModule.currentOpportunityLostReason;
    }

    get loadingOpportunityLostReasons() {
        return AgencySettingsModule.loadingOpportunityLostReasons;
    }

    get opportunityLostReasons() {
        return AgencySettingsModule.opportunityLostReasons;
    }

    async deleteOpportunityLostReason() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "DELETE",
            buttonFalseText: "CANCEL",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete this Opportunity Lost Reason?', options);
        if (result) {
            AgencySettingsModule.deleteOpportunityLostReason(this.currentOpportunityLostReason);
        }
    }
}
